import { render, staticRenderFns } from "./RequestAppointmentPetsPage.vue?vue&type=template&id=448b0b4d&"
import script from "./RequestAppointmentPetsPage.vue?vue&type=script&lang=js&"
export * from "./RequestAppointmentPetsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports